/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router';
import { getTranslation, languages } from 'src/utils';
import { Button, Divider, Grid, IconButton, useTheme, Drawer } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { MainMenu, MobileHeader, Logo, UserIcon, LogoutIcon, QuickLinks, OverflowTip } from '../../components';
import { useStyles } from './styles';
import { getTranslations } from './defaultLayoutService';
import { useApiError, useAppData, useLoading } from '../../providers';
import { trackAmplitudeData } from '../../services/amplitudeService';
import { SelectLanguageDialog } from './SelectLanguageDialog';

export const DefaultLayout = memo(({ children }) => {
  const classes = useStyles();
  const { setIsLoading } = useLoading();
  const { addError } = useApiError();
  const theme = useTheme();
  const {
    translations,
    removeToken,
    saveCurrentPage,
    removeUserData,
    saveTranslations,
    userData,
    removeTranslations,
    removeCurrencyList,
    removePartnershipList,
    removeClientPortalRedirectUrl,
    saveLocale,
    removeLogoUrl,
    removeFooterLogoUrl,
    removeQRLogoUrl,
    locale,
  } = useAppData();
  const [translation, setTranslation] = useState<any>([]);
  const location = useLocation();
  const [selectedLocale, setSelectedLocale] = useState<any>(languages[0]);
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const [userName, setUserName] = useState<string>('');
  const [userID, setUserID] = useState<string>('');
  const [userRole, setUserRole] = useState<string>('');
  const [openLanguageDialog, setOpenLanguageDialog] = useState(false);

  useEffect(() => {
    console.log(window.innerHeight);
  }, []);

  useEffect(() => {
    setTranslation(JSON.parse(translations));
  }, [translations]);

  useEffect(() => {
    if (locale) {
      const selectedLanguage = languages.find((item) => item.value === locale) || languages[0];
      setSelectedLocale(selectedLanguage);
    }
  }, []);

  useEffect(() => {
    const user = JSON.parse(userData);
    setUserName(user.userDisplayName);
    setUserID(user.partnerID);
    setUserRole(getTranslation(translation, user.accounts[0].userRoleName));
  }, [userData]);

  const getTranslationList = useCallback(
    async (newLocale: string) => {
      try {
        setIsLoading(true);
        const translations = await getTranslations();
        saveTranslations(JSON.stringify(translations.data));
        setTranslation(translations.data);
        saveLocale(newLocale);
      } catch (error) {
        addError(JSON.stringify(error.response));
      } finally {
        setIsLoading(false);
      }
    },
    [saveTranslations, saveLocale, addError, setIsLoading],
  );

  const handleLocaleChange = useCallback(
    async (value: string) => {
      setOpenLanguageDialog(false);
      const selectedLanguage = languages.find((item) => item.value === value) || languages[0];
      setSelectedLocale(selectedLanguage);
      saveLocale(selectedLanguage.value);
      if (selectedLanguage.value !== languages[0].value) {
        trackAmplitudeData('partnerPortal_action_languageChanged', {
          page_language: selectedLanguage.value,
        });
      }
      await getTranslationList(selectedLanguage.value);
    },
    [getTranslationList],
  );

  const handleLogout = useCallback(() => {
    saveCurrentPage(location.pathname.replace('/', ''));
    setIsLoading(true);
    removeToken();
    removeUserData();
    removeTranslations();
    removeCurrencyList();
    removePartnershipList();
    removeClientPortalRedirectUrl();
    removeFooterLogoUrl();
    removeQRLogoUrl();
    removeLogoUrl();
    setIsLoading(false);
    saveLocale('en');
  }, [removeToken, location, saveCurrentPage, removeUserData, removeTranslations, removeCurrencyList, removePartnershipList, removeClientPortalRedirectUrl, setIsLoading, saveLocale, removeLogoUrl, removeQRLogoUrl, removeFooterLogoUrl]);

  return (
    <div className={classes.root}>
      <MobileHeader translation={translation} handleShowMenu={() => setShowMenu(true)} />
      <div className={classes.container}>
        <Drawer anchor={theme.direction === 'rtl' ? 'left' : 'right'} open={showMenu}>
          <Grid container direction="column" className={classes.mobileContainer}>
            <Grid container direction="row" alignContent="center" alignItems="center" justify="space-between" className={classes.logo}>
              <Grid item>
                <Logo translation={translation} />
              </Grid>
              <Grid item>
                <IconButton className={classes.closeBtn} onClick={() => setShowMenu(false)}>
                  <Close />
                </IconButton>
              </Grid>
            </Grid>
            <Grid item style={{ marginInlineStart: 15 }}>
              <QuickLinks />
            </Grid>
            <Grid item style={{ marginInlineStart: 15 }}>
              <MainMenu />
            </Grid>
            <Grid className={classes.menuSpace} />
            <Grid container direction="column" className={classes.bottomSection} style={{ marginInlineStart: 20 }}>
              <Divider orientation="horizontal" />
              <Button
                className={`${classes.menuButton} ${classes.languageBtn}`}
                startIcon={selectedLocale.icon}
                onClick={() => {
                  setOpenLanguageDialog(true);
                }}
              >
                {selectedLocale.label}
              </Button>
              <Grid container direction="row" alignItems="center">
                <UserIcon />{' '}
                <Grid item style={{ marginInlineStart: 8, textAlign: 'start' }}>
                  <p className={classes.userName}>
                    <OverflowTip interactive align="start" title={userName}>
                      {userName}
                    </OverflowTip>
                  </p>
                  {userRole === 'Partner' ? <p className={classes.id}>ID:{userID}</p> : <p className={classes.id}>{userRole}</p>}
                </Grid>
              </Grid>
              <Button className={classes.menuButton} startIcon={<LogoutIcon />} onClick={handleLogout}>
                {translation.text_6040}
              </Button>
            </Grid>
          </Grid>
        </Drawer>
        <Grid container direction="column" className={classes.drawer} style={{ height: window.innerHeight }}>
          <Grid item className={classes.logo}>
            <Logo translation={translation} />
          </Grid>
          <Grid item>
            <QuickLinks />
          </Grid>
          <Grid item style={{ marginInlineStart: 15 }}>
            <MainMenu />
          </Grid>
          <Grid className={classes.menuSpace} />
          <Grid container direction="column" className={classes.bottomSection}>
            <Divider orientation="horizontal" />
            <Grid container direction="row" alignItems="center" style={{ paddingInlineStart: 5 }}>
              <UserIcon />{' '}
              <Grid item style={{ marginInlineStart: 8, textAlign: 'start' }}>
                <p className={classes.userName}>
                  <OverflowTip interactive align="start" title={userName}>
                    {userName}
                  </OverflowTip>
                </p>
                {userRole === 'Partner' ? <p className={classes.id}>ID:{userID}</p> : <p className={classes.id}>{userRole}</p>}
              </Grid>
            </Grid>
            <Button className={classes.logoutButton} style={{ marginInlineStart: 2 }} startIcon={<LogoutIcon />} onClick={handleLogout}>
              {translation.text_6040}
            </Button>
          </Grid>
        </Grid>
        <main className={classes.main}>{children}</main>
      </div>
      <SelectLanguageDialog translation={translation} selectedValue={selectedLocale.label} open={openLanguageDialog} onChange={handleLocaleChange} onClose={() => setOpenLanguageDialog(false)} />
    </div>
  );
});
